
import { TableInitialState } from "@sinecycle/growcomponents";
import produce from "immer";
import { atom } from "jotai";

const tableInitialState: TableInitialState<any> = {
  currentPage: 1,
  bulk_records: 1,
  selectAll: {
    select_all: false,
    selected: false,
  },
  selectedRows: [],
};

export const tableAtom = atom(tableInitialState);

export const resetSelectedRowsPredicate = <T>(value: TableInitialState<T>) => {
  return produce(value, (draft) => {
    draft.selectedRows = [];
    return draft;
  });
};

export const resetSelectAllPredicate = <T>(value: TableInitialState<T>) => {
  return produce(value, (draft) => {
    draft.selectAll = tableInitialState.selectAll;
    return draft;
  });
};

export const updateSelectAllPredicate = <T>(value: TableInitialState<T>) => {
  return produce(value, (draft) => {
    draft.selectAll = { select_all: true, selected: true };
    return draft;
  });
};

export const resetPage = <T>(value: TableInitialState<T>) => {
  return produce(value, (draft) => {
    draft.currentPage = 1;
    return draft;
  });
};
